import React from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import useMobile from '../hooks/use-mobile';
const StyledContainer = styled.View`
  flex-direction: ${props => props.mobile ? 'column' : 'row'};
  gap: 24px;
`;
export default function Container(props) {
  const mobile = useMobile();
  return /*#__PURE__*/React.createElement(StyledContainer, {
    mobile: mobile
  }, props.children);
}
Container.propTypes = {
  children: PropTypes.node
};
Container.defaultProps = {
  children: ''
};
//# sourceMappingURL=container.js.map